import type { DashboardOverview } from '@/lib/types';
import StatCard from './StatCard';
import SimpleBarChart from './SimpleBarChart';
import RecentActivity from './RecentActivity';
import QuickActions from './QuickActions';

interface StudentDashboardProps {
  data: DashboardOverview;
}

export default function StudentDashboard({ data }: StudentDashboardProps) {
  const { stats, chart, recent_activity } = data;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <StatCard label="Enrollments" value={stats.enrollments ?? 0} accent="blue" />
        <StatCard
          label="Overall progress"
          value={`${stats.overall_progress ?? 0}%`}
          accent="teal"
          hint={`${stats.lessons_completed ?? 0}/${stats.lessons_total ?? 0} lessons`}
        />
        <StatCard label="Certificates" value={stats.certificates ?? 0} accent="amber" />
        <StatCard label="Badges" value={stats.badges ?? 0} accent="violet" />
      </div>

      <QuickActions
        actions={[
          { label: 'Browse Courses', to: '/courses' },
          { label: 'View Progress', to: '/progress', variant: 'secondary' },
          { label: 'Certificates', to: '/certificates', variant: 'secondary' },
        ]}
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <SimpleBarChart
          title={chart.title}
          items={chart.items}
          valueSuffix="%"
          emptyMessage="Enroll in a course to see progress here."
        />
        <RecentActivity
          items={recent_activity}
          emptyMessage="Complete lessons to see recent activity."
        />
      </div>
    </div>
  );
}
